import type { LucideIcon } from 'lucide-react'
import {
    BadgeDollarSign,
    CircleCheck,
    ClockArrowDown,
    FileText,
    Handshake,
    Headset,
    ShieldHalf,
    Smartphone,
    Truck,
    UsersRound,
    Wallet,
    Zap,
} from 'lucide-react'
import type { PromoPageIcon } from '@numeo/types-main-mobile'

/** Same lucide icons the app draws for each feature (`PromoPageBody` in the mobile app). */
export const PROMO_PAGE_ICON_COMPONENTS: Record<PromoPageIcon, LucideIcon> = {
    'clock-arrow-down': ClockArrowDown,
    'users-round': UsersRound,
    'shield-half': ShieldHalf,
    'badge-dollar-sign': BadgeDollarSign,
    zap: Zap,
    truck: Truck,
    handshake: Handshake,
    wallet: Wallet,
    headset: Headset,
    smartphone: Smartphone,
    'circle-check': CircleCheck,
    'file-text': FileText,
}
